<!--
  =======================================================================
  ======= DEPRECATION WARNING ===========================================
  =======================================================================
  The following component will be soon deprecated
  maintenance mode only until the end of migration of CP2.0
  for new features/current development please use:
  `apps/back-office-seller/scopes/customer-care/pages/customer-request/Request.vue`
-->
<template>
  <MissingReturnAddressModal />
  <div class="flex max-h-screen min-h-screen w-full overflow-hidden">
    <Sidebar />

    <div class="grow">
      <div v-if="customerRequest" class="flex h-full max-h-full flex-col">
        <Header
          :customer-request-id="customerRequest.customerRequestId"
          data-test="header"
          :is-loading="isPending"
          :orderline="customerRequest.orderline"
          :product="customerRequest.product"
          :product-return-kind="customerRequest.productReturn?.kind"
          :product-return-state="customerRequest.productReturnState"
          :repair-status="customerRequest.repairStatus"
        />

        <RevLoadingScreen
          v-if="isPending"
          class="h-full"
          :text="i18n(translations.loading)"
        />
        <Main v-else :customer-request @refresh-customer-request="refresh" />
      </div>

      <div v-else class="h-full p-12">
        <RevLoadingScreen
          v-if="isPending"
          class="h-full"
          :text="i18n(translations.loading)"
        />
        <ErrorInfoBlock v-else @try-again="refresh" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData, useRoute } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import ErrorInfoBlock from '../../components/ErrorInfoBlock/ErrorInfoBlock.vue'
import MissingReturnAddressModal from '../../components/MissingReturnAddressModal/MissingReturnAddressModal.vue'
import Sidebar from '../../components/Sidebar/Sidebar.vue'

import translations from './CustomerRequest.translations'
import Header from './components/Header/Header.vue'
import Main from './components/Main/Main.vue'

const route = useRoute()
const i18n = useI18n()
const $httpFetch = useHttpFetch()

const {
  data: customerRequest,
  refresh,
  status,
} = useAsyncData(`customer-request-${route.params.customerRequestId}`, () =>
  $httpFetch('/bm/care-folders/:careFolderId', {
    pathParams: {
      careFolderId: route.params.customerRequestId.toString(),
    },
  }),
)

const isPending = computed(() => status.value === 'pending')
</script>
